import {put, call, cancel} from 'redux-saga/effects';
import Creators, {forgetPasswordFailed} from '../state/AppRedux';
import {interventionService} from '../services/interventionService';
import {validateFormErrorResponse} from '../helpers';
import {navigate} from 'gatsby';
import { questionsService } from '../services/questionsService';

// submit intervention
export function* submitIntervention(answers) {
	yield put(Creators.fetching());
	//
	let result = null;
	try {
		result = yield call(interventionService.submitInterventionRequest, answers);
		if (result.data.response) {
			yield put(Creators.submitFirstInterventionPhaseSuccessfully(result.data.response));
		}
	} catch (e) {
		if (e.status === 401) {
			yield put(Creators.logout());
			navigate('/');
		}
		// console.log('e', e);
		// const validationMessages = validateFormErrorResponse(e.answers.response);
		// yield put(Creators.updatePasswordFailed(validationMessages))
	}
}


// get all intervention questions
export function* getAllIntervention(data) {
	yield put(Creators.fetching());
	
	let result = null;
	try {
		result = yield call(interventionService.getIntervention, data);
		// console.log(result.data.response, "its data saga");
		if (result && result.data.response) {
			yield put(Creators.interventionFetchedSuccessfully(result.data.response));
		}
	} catch (e) {
		if (e.status === 401 || e.status === 412) {
			yield put(Creators.logout());
			navigate('/login');
		}
		yield put(Creators.stopFetching());
	}
}

export function* sendAnswers(action) {
	// console.log('send answers action: ', action);
	yield put(Creators.submittingAnswers());
	// Fetch the temperature from an API
	let response = null;
	try {
		response = yield call(questionsService.postAnswers, action.data);
	} catch (e) {
		response = e;
	}
	
	if (response && response.status === 200) {
		yield put(Creators.partiallyResetIntervention());
		yield put(Creators.answersSubmittedSuccessfully());
	} else {
		if (response.data !== null && typeof response.data === 'object') { // for request timed out logging
			if (response.data.code === 412) {
				yield put(Creators.resetAuthToken(true));
				// action.navigation.navigate('LoginScreen', {redirectMessage: 'Please login to continue.', replace: true})
				navigate('/login');
			} else {
				//bugsnag.notify(response)
				yield put(Creators.answersSubmissionFailed(response.data.response));
			}
		} else { // log timed out request
			//bugsnag.notify(response)
			yield put(Creators.answersSubmissionFailed(response.data));
		}
	}
}

export function * sendAnswersAndFetchActions (action) {
	// console.log('sendAnswersAndFetchActions');
	// console.log(action);
	yield put(Creators.submittingAnswers());
	// Fetch the temperature from an API
	let response = null;
	try {
		response = yield call(questionsService.postAnswers, action.data);
	} catch (e) {
		//bugsnag.notify(e)
		// console.log(e);
		response = e;
	}
	// console.log('reeeeeeeeeesssspppppppp\n', response);
	if (response && response.status === 200) {
		yield put(Creators.resetIntervention(true));
		yield put(Creators.fetchActions(action.data.authToken));
		yield put(Creators.answersSubmittedSuccessfully());
	} else {
		// console.log(response);
		if (response.data !== null && typeof response.data === 'object') { // for request timed out logging
			// console.log(response);
			if (response.status === 412) {
				yield put(Creators.resetAuthToken(true));
				//action.navigation.navigate('LoginScreen', { redirectMessage: 'Please login to continue.', replace: true })
				navigate('/login');
			} else {
				//bugsnag.notify(response)
				// console.log(response);
				yield put(Creators.answersSubmissionFailed(response.data.response));
			}
		} else { // log timed out request
			//bugsnag.notify(response)
			// console.log(response);
			yield put(Creators.answersSubmissionFailed(response.data));
		}
	}
}

